import {
  TASK_CHOICE_AUTOCOMPLETE_OPTIONS,
  TASK_KIND_AUTOCOMPLETE_OPTIONS,
} from '@/constants/filterCriteria/tasks';
import FormWithFetchAutocompleteByIdTFC from '@components/LoadSearchTemplateDialog/templateFormControls/FetchAutocompleteByIdTFC';
import TextTFC from '@components/LoadSearchTemplateDialog/templateFormControls/TextTFC';
import { FieldMetaData } from '@components/LoadSearchTemplateDialog/templateFormControls/types';

import type {
  MappedTemplateFormControlMapDeps,
  TemplateFormControlMap,
} from '@components/LoadSearchTemplateDialog/mappedTemplateFormControl/types';

export function buildTaskEventAndCallingControls(
  deps: MappedTemplateFormControlMapDeps
): Partial<TemplateFormControlMap> {
  const {
    lookupElections,
    lookupEvents,
    lookupCampaigns,
    lookupEventTypes,
    lookupUsers,
    initialValue,
    simpleInitialValue,
    matchedInitialValue,
  } = deps;

  return {
    'task.electionIds': ({ onChildChange }) => (
      <FormWithFetchAutocompleteByIdTFC
        label={'Add an election'}
        onChange={onChildChange}
        minLength={3}
        lookup={lookupElections}
        initialValue={initialValue}
      />
    ),
    'task.kinds': ({ onChildChange }) => (
      <FormWithFetchAutocompleteByIdTFC
        label={'Add a task'}
        idType="string"
        onChange={onChildChange as (value: string[], fieldMetaData: FieldMetaData) => void}
        preLoadedOptions={TASK_KIND_AUTOCOMPLETE_OPTIONS}
        initialValue={matchedInitialValue}
      />
    ),
    'task.note': ({ onChildChange }) => (
      <TextTFC
        label={'Task note (optional)'}
        onChange={onChildChange}
        variant="filled"
        initialValue={simpleInitialValue as string}
      />
    ),
    'task.choices': ({ onChildChange }) => (
      <FormWithFetchAutocompleteByIdTFC
        label={'Add a status'}
        idType="string"
        onChange={onChildChange as (value: string[], fieldMetaData: FieldMetaData) => void}
        preLoadedOptions={TASK_CHOICE_AUTOCOMPLETE_OPTIONS}
        initialValue={matchedInitialValue}
      />
    ),
    'eventAttendance.eventIds': ({ onChildChange }) => (
      <FormWithFetchAutocompleteByIdTFC
        label={'Event name(s) (optional)'}
        onChange={onChildChange}
        minLength={3}
        lookup={lookupEvents}
        isEmptyValid
        initialValue={initialValue}
      />
    ),
    'eventAttendance.eventCampaignIds': ({ onChildChange }) => (
      <FormWithFetchAutocompleteByIdTFC
        label={'Held by campaign(s) (optional)'}
        onChange={onChildChange}
        minLength={3}
        lookup={lookupCampaigns}
        isEmptyValid
        initialValue={initialValue}
      />
    ),
    'eventAttendance.eventTypeIds': ({ onChildChange }) => (
      <FormWithFetchAutocompleteByIdTFC
        label={'Event type(s) (optional)'}
        onChange={onChildChange}
        minLength={3}
        lookup={lookupEventTypes}
        isEmptyValid
        initialValue={initialValue}
      />
    ),
    'callingStatus.callingStatusUserSubs': ({ onChildChange }) => (
      <FormWithFetchAutocompleteByIdTFC
        label={'Contacted by user(s) (optional)'}
        idType="string"
        onChange={onChildChange}
        minLength={3}
        lookup={lookupUsers}
        isEmptyValid
        initialValue={initialValue}
      />
    ),
  };
}
